(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.headerBounds.top + 100) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startup-rev-audience-middle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('[data-sr-lite-yt]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      if (btn.dataset.srLiteYtBound === 'true') return;
      btn.dataset.srLiteYtBound = 'true';

      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yt-id');
        if (!id) return;

        var iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1'
        );
        iframe.setAttribute('title', btn.getAttribute('aria-label') || 'YouTube video');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'eager');
        iframe.className = 'sr-lite-yt__iframe';

        var wrap = document.createElement('div');
        wrap.className = 'sr-lite-yt sr-lite-yt--active';
        wrap.appendChild(iframe);

        if (btn.parentNode) {
          btn.parentNode.replaceChild(wrap, btn);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startup-rev-speaker-profile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.sr-speaker-profile');
    if (!root) return;

    var items = root.querySelectorAll('[data-srp-reveal]');
    if (!items.length) return;

    var show = function (el) { el.classList.add('is-revealed'); };

    if (!('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startup-rev-speaker-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('.srp-related .sr-speakers-grid');
    if (!grid) return;

    var reveal = function () {
      grid.querySelectorAll('[data-sr-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    };

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal();
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -80px 0px' });

    io.observe(grid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startup-rev-speakers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grids = document.querySelectorAll('.sr-speakers-grid');
    if (!grids.length) return;

    var reveal = function (root) {
      root.querySelectorAll('[data-sr-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    };

    if (!('IntersectionObserver' in window)) {
      grids.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px' });

    grids.forEach(function (grid) { io.observe(grid); });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startup-rev-what-to-expect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('[data-sr-lite-yt]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      if (btn.dataset.srLiteYtBound === 'true') return;
      btn.dataset.srLiteYtBound = 'true';

      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yt-id');
        if (!id) return;

        var iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1'
        );
        iframe.setAttribute('title', btn.getAttribute('aria-label') || 'YouTube video');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'eager');
        iframe.className = 'sr-lite-yt__iframe';

        var wrap = document.createElement('div');
        wrap.className = 'sr-lite-yt sr-lite-yt--active';
        wrap.appendChild(iframe);

        if (btn.parentNode) {
          btn.parentNode.replaceChild(wrap, btn);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
